import { useTheme } from '@mui/material/styles';
import { Box, Paper, Stack, Typography } from '@mui/material';
import CloseButton from 'components/CloseButton';
import UserAvatar from 'components/UserAvatar';
import { EventUser } from 'services/signaling';
import React from 'react';
import { NotificationId } from 'features/notifications/types';

export type JoinNotificationTemplateProps = {
  // eslint-disable-next-line react/no-unused-prop-types
  id: NotificationId;
  closeToast?: () => void;
  initiator?: EventUser;
  content?: React.ReactNode;
};

const JoinNotificationTemplate = ({
  closeToast,
  initiator,
  content,
}: JoinNotificationTemplateProps) => {
  const close = () => {
    closeToast?.();
  };

  const handleClose = () => {
    close();
  };

  const theme = useTheme();

  return (
    <Paper
      elevation={theme.palette.mode === 'dark' ? 6 : 0}
      sx={{
        position: 'relative',
        borderRadius: '8px',
        width: '100%',
      }}
    >
      <Box
        sx={{
          top: 6,
          right: 6,
          position: 'absolute',
        }}
      >
        <CloseButton onClick={handleClose} />
      </Box>
      <Box
        sx={{
          padding: theme.spacing(3, 10, 4, 3),
        }}
      >
        <Stack spacing={3} direction="row">
          {initiator && (
            <UserAvatar
              src={initiator.avatarUrl}
              initials={initiator.initials}
              name={initiator.name}
              color={initiator.avatarColor || '#000'}
              sx={{ width: 28, height: 28, fontSize: 12 }}
            />
          )}
          <Box
            sx={{
              pt: 0.5,
            }}
          >
            {typeof content === 'string' ? (
              <Typography
                variant="body2"
                data-testid="notification-text-content"
                sx={{
                  whiteSpace: 'pre-wrap',
                  overflowWrap: 'anywhere',
                }}
              >
                {content}
              </Typography>
            ) : (
              content
            )}
          </Box>
        </Stack>
      </Box>
    </Paper>
  );
};

export default JoinNotificationTemplate;
